module.exports = __webpack_public_path__ + "assets/img/ab5-1.9b5d6990.png";